import z from "zod";

export const RegisterVerificationSchema = z.object({
  code: z.string().min(1, "Code is required"),
});

export type RegisterVerificationFormValues = z.infer<typeof RegisterVerificationSchema>;
